<template>
  <input
    v-if="props.item.file"
    ref="fileInputRef"
    :class="DS_FILE_UPLOAD_CLASSES.Input"
    type="file"
    :name="props.fileFieldName"
    :disabled="props.disabled"
    tabindex="-1"
    aria-hidden="true"
  />

  <input
    type="hidden"
    :name="props.filenameFieldName"
    :value="props.item.name"
    :disabled="props.disabled"
  />
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { DS_FILE_UPLOAD_CLASSES } from "../constants/classes";
import { resetNativeFileInput, setNativeFileInputFiles } from "../utils/nativeFileInput";
import type { DSFileUploadItem } from "../types";

interface DSFileUploadNativeFileFieldProps {
  item: DSFileUploadItem;
  disabled: boolean;
  fileFieldName: string;
  filenameFieldName: string;
}

const props = defineProps<DSFileUploadNativeFileFieldProps>();
const fileInputRef = ref<HTMLInputElement>();

onMounted(syncNativeFileInput);

watch(() => props.item.file, syncNativeFileInput, { flush: "post" });

function syncNativeFileInput(): void {
  if (!fileInputRef.value) return;

  const file = props.item.file;
  if (!file) {
    resetNativeFileInput(fileInputRef.value);
    return;
  }

  setNativeFileInputFiles(fileInputRef.value, [file]);
}
</script>
